/* unplugin-vue-components disabled */import { render } from "./founder.vue?vue&type=template&id=dcb8c7ea"
import script from "./founder.vue?vue&type=script&lang=js"
export * from "./founder.vue?vue&type=script&lang=js"

import "./founder.vue?vue&type=style&index=0&id=dcb8c7ea&lang=css"

import exportComponent from "F:\\vue2.0+ vant\\2024年项目集合\\元羿官网项目集合\\元羿中文版本\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__